/* eslint-disable new-cap */
import merge from 'lodash/merge';
import ReactApexChart from 'react-apexcharts';
// @mui
import { useTheme, styled } from '@mui/material/styles';
import { Card, CardHeader } from '@mui/material';
import BaseOptionChart from './chart/BaseOptionChart';
import { fNumber } from '../utils/formatNumber';

// ----------------------------------------------------------------------

const CHART_HEIGHT = 392;
const LEGEND_HEIGHT = 72;

export const ChartWrapperStyle = styled('div')(({ theme }) => ({
  height: CHART_HEIGHT,
  marginTop: theme.spacing(5),
  '& .apexcharts-canvas svg': { height: CHART_HEIGHT },
  '& .apexcharts-canvas svg,.apexcharts-canvas foreignObject': {
    overflow: 'visible',
  },
  '& .apexcharts-legend': {
    height: LEGEND_HEIGHT,
    alignContent: 'center',
    position: 'relative !important',
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`,
  },
}));

// ----------------------------------------------------------------------

export interface IPiChart {
  colors: string[];
  labels: string[];
  title: string;
  chartData: number[];
  chartToolTipFormatter?: Function;
  chartUnit?: string;
}
export default function PiChart({
  title,
  colors,
  labels,
  chartData,
  chartToolTipFormatter,
  chartUnit,
}: IPiChart) {
  const theme = useTheme();

  const chartOptions: any = merge(BaseOptionChart(), {
    series: chartData,
    colors: colors,
    labels: labels,
    stroke: { colors: [theme.palette.background.paper] },
    legend: {
      floating: true,
      horizontalAlign: 'center',
    },
    fill: {
      type: ['gradient'],
      gradient: {
        shade: 'light',
        type: 'horizontal',
        shadeIntensity: 0.25,
        opacityFrom: 0.4,
        opacityTo: 0.9,
        stops: [0, 100],
      },
    },
    tooltip: {
      fillSeriesColor: false,
      y: {
        formatter: (seriesName: any) => `${fNumber(seriesName)} ${chartUnit || ''}`,
        title: {
          formatter: (seriesName: any) => `${seriesName}`,
        },
      },
      custom: chartToolTipFormatter,
    },
    plotOptions: {
      pie: {
        donut: {
          size: '60%',
          labels: {
            value: {
              formatter: (val: number) => fNumber(val),
            },
            total: {
              formatter: (w: any) => {
                const sum = w.globals.seriesTotals.reduce((a: number, b: number) => a + b, 0);
                return fNumber(sum);
              },
            },
          },
        },
      },
    },
  });

  return (
    <Card>
      <CardHeader title={title} />
      <ChartWrapperStyle dir="ltr">
        {/* @ts-ignore*/}
        <ReactApexChart type="donut" series={chartData} options={chartOptions} height={280} />
      </ChartWrapperStyle>
    </Card>
  );
}
